<template>
  <div>
    <div class="popup-wrapper">
      <div class="inner">
        <img
          src="@/assets/img/newGlobal/introduce/sub/recruit/popup/close.png"
          alt="close"
          class="popup-close"
          @click="closePopup"
        />
        <div class="content">
          <p class="title-text">지원서 등록</p>
          <ul class="form">
            <li>
              <p>지원분야<span>*</span></p>
              <div class="field-wrapper">
                <select v-model="selectedSector" @change="changeSector">
                  <option value="">선택</option>
                  <option
                    v-for="(value, key) in sectorList"
                    :value="key"
                    :key="key"
                    :selected="key === selectedSector2"
                  >
                    {{ value.deptname }}
                  </option>
                </select>

                <select v-model="selectedDuty">
                  <option value="">선택</option>
                  <option
                    v-for="(value, key) in dutyList"
                    :value="key"
                    :key="key"
                  >
                    {{ value.deptname }}
                  </option>
                </select>
              </div>
            </li>
            <li>
              <p>이력서/자기소개서<span>*</span></p>
              <div class="resume-wrapper">
                <input
                  type="file"
                  name="resume"
                  id="resume"
                  ref="resumeInput"
                />
                <p>* 2개 이상 파일 첨부 시 압축하여 첨부해주시기 바랍니다.</p>
              </div>
            </li>
            <li class="name-wrapper">
              <p>이름<span>*</span></p>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="이름을 입력해주세요."
                v-model="name"
              />
            </li>
            <li class="email-wrapper">
              <p>이메일<span>*</span></p>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="이메일 주소를 입력해주세요."
                v-model="email"
              />
            </li>
            <li>
              <p>연락처<span>*</span></p>
              <div class="phone-wrapper">
                <input type="tel" name="mobile" id="mobile" v-model="mobile" />
                <p><span>*</span>는 <span>필수입력사항</span>입니다.</p>
              </div>
            </li>
          </ul>
          <div class="portfolio-wrapper">
            <p>포트폴리오 링크</p>
            <input
              type="text"
              name="portfolio"
              id="portfolio"
              placeholder="포트폴리오 URL 주소를 입력해주세요."
              v-model="portfolio"
            />
            <p>
              * URL 오타 및 링크 기간 만료 등으로 인해 확인이 불가하여 생기는
              불이익은 책임지지 않습니다.
            </p>
          </div>
          <div class="textarea-wrapper">
            <p>기타 내용 입력</p>
            <textarea
              name="contents"
              id="contents"
              v-model="contents"
            ></textarea>
          </div>
          <div class="agree-wrapper">
            <input
              type="checkbox"
              name="agree"
              id="agree"
              value="Y"
              v-model="agree"
            />
            <label for="agree">개인정보 수집 및 이용에 동의합니다.</label>
          </div>
          <div class="go-sign" @click="goRecruit"><p>등록하기</p></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {
  // Con2.vue에서 지원분야 값 받아오기
  props: {
    selectedSector2: {
      type: String,
      required: true,
    },
    selectedDuty2: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sectorList: [],
      dutyList: [],
      selectedSector: "",
      selectedDuty: "",
      name: "",
      email: "",
      mobile: "",
      portfolio: "",
      contents: "",
      agree: false,
    };
  },
  created() {
    this.getRecruitSector();
  },
  methods: {
    // 팝업 닫기
    closePopup() {
      this.$emit("closeSupportPopup");
    },

    // 지원부서 데이터 가져오기
    getRecruitSector() {
      this.axios
        .get(`/rest/external/getRecruitSector`)
        .then((res) => {
          this.sectorList = res.data.list;
          for (let i = 0; i < this.sectorList.length; i++) {
            if (this.sectorList[i].deptname == this.selectedSector2) {
              this.selectedSector = i;
              this.loadDuty();
            }
          }
        })
        .catch((err) => {
          alert(`err : ${err}`);
        });
    },

    // 지원부서 정보를 기준으로 파트 데이터 가져오기
    loadDuty() {
      this.axios
        .get(
          `/rest/external/getRecruitDuty?idx=` +
            this.sectorList[this.selectedSector].deptcode
        )
        .then((res) => {
          this.dutyList = res.data.list;
          for (let i = 0; i < this.dutyList.length; i++) {
            if (this.dutyList[i].deptname == this.selectedDuty2) {
              this.selectedDuty = i;
            }
          }
        })
        .catch((err) => {
          alert(`통신이 원활하지 않습니다.`);
          console.log("err : ", err);
        });
    },

    // 지원부서 바뀔 때 파트 초기화
    changeSector() {
      this.selectedDuty = "";
      this.loadDuty();
    },

    // 지원하기
    goRecruit() {
      if (!this.sectorList[this.selectedSector].deptcode) {
        alert("지원분야를 선택하십시오.");
      } else if (!this.dutyList[this.selectedDuty].deptcode) {
        alert("지원분야2를 선택하십시오.");
      } else if (!this.$refs.resumeInput.files[0]) {
        alert("이력서/자기소개서를 업로드 하십시오.");
      } else if (!this.name) {
        alert("이름을 입력하십시오.");
      } else if (!this.email) {
        alert("이메일을 입력하십시오.");
      } else if (!this.mobile) {
        alert("연락처를 입력하십시오.");
      } else if (!this.agree) {
        alert("개인정보 수집 및 이용에 동의 하신 후 등록가능합니다.");
      } else {
        const params = new FormData();
        params.append("sector", this.sectorList[this.selectedSector].deptcode);
        params.append("duty", this.dutyList[this.selectedDuty].deptcode);
        params.append("name", this.name);
        params.append("email", this.email);
        params.append("phone", this.mobile);
        params.append("portfolio", this.portfolio);
        params.append("contents", this.contents);
        params.append("resume", this.$refs.resumeInput.files[0]);

        // 데이터 확인을 위한 console.log
        // console.log("전송되는 데이터:", {
        //   sector: this.sectorList[this.selectedSector].deptcode,
        //   duty: this.dutyList[this.selectedDuty].deptcode,
        //   name: this.name,
        //   email: this.email,
        //   phone: this.mobile,
        //   portfolio: this.portfolio,
        //   contents: this.contents,
        //   resume: this.$refs.resumeInput.files[0],
        // });

        axios
          .post("/rest/external/addRecruit", params)
          .then((res) => {
            if (res.data.err == 0) {
              alert("지원이 완료되었습니다.");

              this.selectedSector = "";
              this.selectedDuty = "";
              this.name = "";
              this.email = "";
              this.mobile = "";
              this.portfolio = "";
              this.contents = "";
              this.$refs.resumeInput.value = "";

              this.closePopup();
            } else {
              console.error("res.data.err : ", res.data.err);
            }
          })
          .catch((err) => {
            alert("통신이 원활하지 않습니다.");
            console.error("err : ", err);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .inner {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: calc(100% - 50px);
    max-width: 700px;

    .popup-close {
      align-self: flex-end;
      cursor: pointer;
    }

    .content {
      background-color: #ffffff;
      padding: 40px;

      .title-text {
        font-size: 30px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 20px;
      }

      input {
        border: 1px solid #e3e5ed;
        padding: 5px;
        border-radius: 0;
      }

      .form {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 20px;

        li {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;

          > p {
            flex: none;
            width: 135px;

            span {
              color: red;
            }
          }

          > div,
          input {
            flex-grow: 1;
          }

          .field-wrapper {
            display: flex;
            flex-direction: column;
            gap: 10px;

            select {
              display: block;
              width: 100%;
              padding: 5px;
              border: 1px solid #e3e5ed;
              appearance: button;
              -moz-appearance: button;
              -webkit-appearance: button;
            }
          }

          .resume-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;

            > p {
              font-size: 13px;
            }
          }

          .phone-wrapper {
            > input {
              width: 100%;
              margin-bottom: 10px;
            }

            > p {
              text-align: right;

              span {
                color: red;
              }
            }
          }
        }
      }

      .portfolio-wrapper {
        margin-bottom: 20px;

        > p {
          &:nth-of-type(1) {
            margin-bottom: 10px;
          }

          &:nth-of-type(2) {
            font-size: 12px;
          }
        }

        > input {
          width: 100%;
          margin-bottom: 5px;
        }
      }

      .textarea-wrapper {
        margin-bottom: 20px;

        > p {
          &:nth-of-type(1) {
            margin-bottom: 10px;
          }
        }

        textarea {
          width: 100%;
          resize: none;
        }
      }

      .agree-wrapper {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-bottom: 20px;
      }

      .go-sign {
        display: flex;
        justify-content: center;

        p {
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          padding: 15px 100px;
          border-radius: 5px;
          background-color: #3f484f;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
